<div>
    <div class="row ">
        <div class="col pl-3">
            <h4 class="mb-0 font-header-1 mb-2" style="font-weight: 700;">Service Delivery Plan Rate</h4>
        </div>
    </div>
    <div *ngIf="global.globalAgencyId==null || global.globalAgencyId==undefined ||global.globalAgencyId=='00000000-0000-0000-0000-000000000000' || this.global.globalAgencyId == '' ">
        <div class="row mt-4 ">
          <div class="col ">
            <div widget class="card border-0 box-shadow">
              <div class="card-body  widget-body pt-2">
                <div class="text-center text-danger">
                  <label class="font-red animate-charcter"><i class="fa fa-info-circle fa-lg"></i>&nbsp;Select agency to view
                    details</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    <div class="row"
        *ngIf="global.globalAgencyId!=null && global.globalAgencyId!='' && global.globalAgencyId!=undefined &&  global.globalAgencyId!='00000000-0000-0000-0000-000000000000'">
        <div class="col ">
            <div class="card-body  widget-body pb-0 pt-2 mb-3">
            </div>
            <div widget class="card border-0 box-shadow">
                <div class="card-header transparent  text-muted">
                    <button type="button" class="btn blue-btn " style="float:right" (click)="SaveOrUpdate()" [disabled]="isSaveorUpdateBoolean">
                        Save
                    </button>
                </div>
                <div class="card-body  widget-body pb-0 pt-2 mb-4">
                    <div class="row">
                        <div class="col-lg-6">
                            <div>
                                <!-- <label class="usrLbl mb-3"><b>CCX Support</b></label> -->
                                <!-- <div class="row ml-1 mb-3">
                                    <div class="col-8">
                                        <input type="checkbox" [(ngModel)]="setting.isCCXWidget"
                                            (ngModelChange)="clearWidgetValues()">&nbsp;
                                        <label for="Client">Turn On widget</label>
                                    </div>
                                </div> -->
                                <div class="row ml-1" >
                                    <div class="col-8">
                                        <label for="Client">Normal Rate</label>
                                        <input type="text" class="form-control styled col-lg-6"
                                            [(ngModel)]="setting.normalRate"  (keypress)="numberonly($event)">&nbsp;
                                    </div>
                                </div>
                                <div class="row ml-1" >
                                    <div class="col-8">
                                        <label for="Client">Enhanced Rate</label>
                                        <input type="text" class="form-control styled col-lg-6"
                                            [(ngModel)]="setting.enhancedRate"  (keypress)="numberonly($event)">&nbsp;
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-6">
                            <div>
                              
                                <!-- <div class="row ml-1" >
                                    <div class="col-8">
                                        <label for="Client">PTO Tax Percent</label>
                                        <input type="text" class="form-control styled col-lg-6"  
                                            [(ngModel)]="setting.ptoTax_Percent"  (keypress)="numberonly($event)">&nbsp;
                                    </div>
                                </div> -->
                                <!-- <div class="row ml-1" >
                                    <div class="col-8">
                                        <label for="Client">Payroll Tax Percent</label>
                                        <input type="text" class="form-control styled col-lg-6" 
                                            [(ngModel)]="setting.payrollTax_Percent" (keypress)="numberonly($event)">&nbsp;
                                    </div>
                                </div> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>